export default "__VITE_ASSET__f99cd616__"